export * from './treeView.service';
export * from './fileList/filesList.service';
import { TreeViewService } from './treeView.service';
import { FilesListApiService } from './fileList/filesList.service';
export const APIS = [TreeViewService, FilesListApiService];
